import React, {useContext, useEffect} from "react";
import {Link, Navigate} from 'react-router-dom'
import {useForm, FormProvider} from "react-hook-form";

import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CircularProgress from '@mui/material/CircularProgress';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import dayjs from 'dayjs';
import 'dayjs/locale/ro';

import * as Formatter from '../../util/Formatter';
import * as TypeConvertor from '../../util/TypeConvertor';
import * as CustomStyles from '../../styles/CustomStyles';
import * as DataPattern from '../../constants/DataPattern';
import * as ValidationMessages from '../../constants/ValidationMessages';
import CustomSelect from '../../custom/CustomSelectComponent'
import * as SelectTypes from '../../constants/CustomSelectTypes'
import BucketContext from "../../context/BucketContext";
import { CourseRegistrationStatus } from "../../constants/Consts";
import * as RestCall from '../../../utils/network/RestCalls';



function EmailRegistrationDialog(props) {
    const bucketContext = useContext(BucketContext);

    const { register, reset, handleSubmit, formState: { errors } } = useForm();

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        reset();
    };

    const handleSubmitCourseRegUpdate = (data, event) => {
        event.preventDefault();

        const emailDetails = data.lEmailDetails;
        emailDetails.authzId = props.authorization.id;
        emailDetails.employeeId = props.authorization.autorizatie.employeeId;

        // props.saveCourseRegistration(course);
        RestCall.sendCourseRegistrationEmail(emailDetails)
            .then(response => bucketContext.setBucketValue({ snackbar: { open: true, severity: "success", message: "Email trimis cu succes" } }))
            .catch(error => bucketContext.setBucketValue({ snackbar: { open: true, severity: "error", message: "Eroare - Emailul nu a putut fi trimis!" } }))
        handleClose();
    }    

    // use 'ro' locale globally
    dayjs.locale('ro');

    return(
        <React.Fragment>

            <Link
                component="button"
                variant="body2"
                onClick={handleClickOpen}
            >
                {props.buttonName}
            </Link>

            <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth={true}>
                <DialogTitle>
                    Inregistrare curs
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                        >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                
                <form id='courseRegistrationForm' onSubmit={ handleSubmit(handleSubmitCourseRegUpdate)} >
                <DialogContent dividers>

                    <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                        {/*row*/}
                        <Grid item xs={8}>
                            <TextField variant="standard" size="small" label="Destinatar" fullWidth margin="dense" 
                                {...register("lEmailDetails.recipientEmailAddress", 
                                    {
                                        required: ValidationMessages.REQUITED_MESSAGE,
                                        pattern: {
                                            value: DataPattern.PATTERN_EMAIL_ADDRESS,
                                            message: ValidationMessages.INVALID_EMAIL_ADDRESS,
                                        }
                                    }
                                )} 
                                error={!!errors?.lEmailDetails?.recipientEmailAddress}
                                helperText={errors?.lEmailDetails?.recipientEmailAddress ? errors.lEmailDetails.recipientEmailAddress.message : null}
                            />
                        </Grid>
                        <Grid item xs={4}>
                        </Grid>

                        {/*row*/}
                        <Grid item xs={8}>
                            <TextField variant="standard" size="small" label="Subiect" fullWidth margin="dense" 
                                {...register("lEmailDetails.subject", {required: ValidationMessages.REQUITED_MESSAGE})} 
                                error={!!errors?.lEmailDetails?.subject}
                                helperText={errors?.lEmailDetails?.subject ? errors.lEmailDetails.subject.message : null}
                            />
                        </Grid>
                        <Grid item xs={4}>
                        </Grid>

                        {/*row*/}
                        <Grid item xs={12}>
                            <TextField variant="standard" id="message-multiline" label="Mesaj" fullWidth margin="dense" 
                                multiline rows={6}
                                {...register("lEmailDetails.message", {required: ValidationMessages.REQUITED_MESSAGE})} 
                                error={!!errors?.lEmailDetails?.message}
                                helperText={errors?.lEmailDetails?.message ? errors.lEmailDetails.message.message : null}
                            />
                        </Grid>

                        { props.authorization.imgAuthzKey ?
                            <React.Fragment>
                                {/*row*/}
                                <Grid item xs={4}>
                                    <CheckCircleOutlineIcon key={Math.random()} color="success" fontSize="large" sx={{mb: 1}} /> Imagine autorizatie
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>
                                        {props.authorization.imgAuthzKey.split('/')[4]}
                                    </Typography>
                                </Grid>
                            </React.Fragment>
                                :
                            <React.Fragment>
                                {/*row*/}
                                <Grid item xs={4}>
                                    <ErrorOutlineIcon key={Math.random()} color="error" fontSize="large" sx={{mb: 1}} /> Imagine autorizatie
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>
                                        N/A
                                    </Typography>
                                </Grid>
                            </React.Fragment>
                        }

                        { props.authorization.imgTalonKey ?
                            <React.Fragment>
                                {/*row*/}
                                <Grid item xs={4}>
                                    <CheckCircleOutlineIcon key={Math.random()} color="success" fontSize="large" sx={{mb: 1}} /> Imagine talon
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>
                                        {props.authorization.imgTalonKey.split('/')[4]}
                                    </Typography>
                                </Grid>
                            </React.Fragment>
                                :
                            <React.Fragment>
                                {/*row*/}
                                <Grid item xs={4}>
                                    <ErrorOutlineIcon key={Math.random()} color="error" fontSize="large" sx={{mb: 1}} /> Imagine talon
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>
                                        N/A
                                    </Typography>
                                </Grid>
                            </React.Fragment>
                        }

                    </Grid>
                
                </DialogContent>

                <DialogActions>
                    <Box sx={{ width:'100%'}} display="flex" justifyContent="flex-end" alignItems="flex-end">
                        <Button onClick={handleClose}>Inchide</Button>
                        <Button type='submit'>Trimite Mesaj</Button>
                    </Box>
                </DialogActions>
                </form>
            </Dialog>

        </React.Fragment>
    );
}



const useConfirmDialog = () => {
    const [open, setOpen] = React.useState(false);
    const [saveCourseRegistration, setSaveCourseRegistration] = React.useState(null);
    const [course, setCourse] = React.useState(null);

    const openDialog = (saveCourse, updatedCourse) => {
        setSaveCourseRegistration(() => e => saveCourse(e));
        setCourse(updatedCourse);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleSubmit =() => {
        saveCourseRegistration(course);
    }

    const props = {
      open,
      handleClose,
      handleSubmit
    };
    return [openDialog, props];
};


const ConfirmCompleteCourse = ({open, handleClose, handleSubmit}) => {
    console.log('__ ConfirmCompleteCourse __');

    const handleConfirmSubmit = () => {
        handleClose();
        handleSubmit();
    }

    return(
        <React.Fragment>
            <Dialog open={open} onClose={handleClose} maxWidth='md'>
                <DialogTitle>
                    Confirmare
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                        >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>
                        Confirmati completarea cursului!
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Inchide</Button>
                    <Button onClick={handleConfirmSubmit} color="error" >Confirmare</Button>
                </DialogActions>
            </Dialog>

        </React.Fragment>
    );
}


const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file)
        fileReader.onload = () => {
          resolve(fileReader.result);
        }
        fileReader.onerror = (error) => {
          reject(error);
        }
      })        
}


const downloadCertificateDoc = async (documentKey) => {
    const fileName = documentKey.split('/')[4];

    return await RestCall.fetchCourseCertUrl(documentKey)
        .then((response) => {
            window.open(response.course_cert_url, '_blank').focus();
        })
        // .then((blob) => {
        //     // Create blob link to download
        //     const url = window.URL.createObjectURL(
        //         new Blob([blob]),
        //     );
        //     const link = document.createElement('a');
        //     link.href = url;
        //     link.setAttribute(
        //         'download',
        //         `${fileName}`,
        //     );
        
        //     // Append to html link element page
        //     document.body.appendChild(link);
        
        //     // Start download
        //     link.click();
        
        //     // Clean up and remove the link
        //     link.parentNode.removeChild(link);
        // })
        .catch(error => console.log(error));    
}


const AuthzIscirCourseManagement = (props) => {
    console.log('AuthorizationISCIRManagement Component___');
    const bucketContext = useContext(BucketContext);

    useEffect(() => {
        if(bucketContext.bucket.mostRecentEeCourseId != null) {
            console.log('Reseting the mostRecentEeCourseId: ' + JSON.stringify(bucketContext.bucket.mostRecentEeCourseId));
            bucketContext.setBucketValue({mostRecentEeCourseId: null});
        }
    });

    const { setValue, register, reset, handleSubmit, formState: { errors, defaultValues } } = useForm({
        defaultValues: {
            lCourseRegistration: props.course,
            employeeId: props.employee.id,
            employerId: props.employee.employmentDetails.employerId
        } 
    });

    const [openConfirmDialog, confirmDialogProps] = useConfirmDialog();

    const [dateCourseValue, setDateCourseValue] = React.useState(dayjs(`${defaultValues.lCourseRegistration.details?.dateCourse}`));
    const [isUploadingData, setIsUploadingData] = React.useState(false);

    const handleSubmitCourseRegUpdate = (data, event) => {
        event.preventDefault();

        const course = data.lCourseRegistration;

        if(course.details.courseStatus === CourseRegistrationStatus.Completed) {
            console.log('Course completed !!!!!');
            openConfirmDialog(props.patchEmployeeCourse, course);
        }
        else {
            props.patchEmployeeCourse(course);
        }
    }    

    const uploadCertificate = async (docToUpload) => {
        const docBase64 = await convertFileToBase64(docToUpload)
        setIsUploadingData(true);
        await props.saveEmployeeCourseCert(docToUpload.name, 
                            docBase64,  
                            defaultValues.employerId, 
                            defaultValues.employeeId, 
                            defaultValues.lCourseRegistration.id);
        setIsUploadingData(false);
    }

    return(
        <Container maxWidth="xl" >
        <Box px={{xs: 3, sm: 7}}>

        <ConfirmCompleteCourse {...confirmDialogProps}/>

            <Stack spacing={1} sx={{marginBottom: 2}}>
                <Box>
                    <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                        <Link to={`/employees/authzs/iscir/${props.authorization.id}`}>
                            Autorizatie {TypeConvertor.getAuthzIscirName(props.authorization.autorizatie.authISCIR)}
                        </Link>
                        <Typography color="text.primary">
                            Curs reautorizare
                        </Typography>
                    </Breadcrumbs>
                </Box>       

                <Box>
                    <h3>{props.employee.generalSection.lastName} {props.employee.generalSection.firstName} - Curs reautorizare</h3>
                </Box>
                <hr/>

                <form id='courseRegistrationForm' onSubmit={ (event) => {
                                                        event.stopPropagation(); 
                                                        handleSubmit(handleSubmitCourseRegUpdate)(event);
                                                    }}
                >
                    <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                        {/*row*/}
                        <Grid item xs={4}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ro'>
                                <DesktopDatePicker
                                    // disabled={!!props.disabled ? props.disabled : false}
                                    label="Data Inscriere la Curs"
                                    inputFormat={DataPattern.DATE_FORMAT_RO}
                                    format={DataPattern.DATE_FORMAT_RO}
                                    value={dateCourseValue}
                                    onChange={(newValue) => {
                                        setDateCourseValue( dayjs(newValue) );
                                        setValue('lCourseRegistration.details.dateCourse', newValue);
                                    }}
                                    renderInput={(params) => 
                                        <TextField {...params} variant="standard" 
                                            {...register('lCourseRegistration.details.dateCourse', {required: ValidationMessages.REQUITED_MESSAGE})}
                                            error={!!errors?.lCourseRegistration?.details?.dateCourse}
                                            helperText={errors?.lCourseRegistration?.details?.dateCourse ? errors.lCourseRegistration.details.dateCourse.message : null}
                                            onChange={(event) => console.log("TextField Chage: " + event.target.value)}
                                        />
                                    }
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField variant="standard" size="small" label="Furnizor Curs" fullWidth margin="dense" 
                                {...register("lCourseRegistration.details.courseProvider", {required: ValidationMessages.REQUITED_MESSAGE})} 
                                error={!!errors?.lCourseRegistration?.details?.courseProvider}
                                helperText={errors?.lCourseRegistration?.details?.courseProvider ? errors.lCourseRegistration.details.courseProvider.message : null}
                            />
                        </Grid>
                        <Grid item xs={4}>
                        </Grid>

                        {/*row*/}
                        <Grid item xs={8}>
                            <TextField
                                variant="standard" 
                                id="outlined-multiline-static"
                                label="Observatii"
                                multiline fullWidth margin="dense" 
                                rows={4}
                                {...register("lCourseRegistration.details.notes")}
                            />
                        </Grid>
                        <Grid item xs={4}>
                        </Grid>

                        {/*row*/}
                        <Grid item xs={4}>
                            <CustomSelect 
                                disabled={false}
                                selectId={'courseStatus'} 
                                selectType={SelectTypes.COURSE_REGISTRATION_STATUS} 
                                value={defaultValues.lCourseRegistration.details?.courseStatus} 
                                register={{...register('lCourseRegistration.details.courseStatus', {required: ValidationMessages.REQUITED_MESSAGE})}}
                                error={!!errors?.lCourseRegistration?.details?.courseStatus}
                                helperText={errors?.lCourseRegistration?.details?.courseStatus ? errors.lCourseRegistration.details.courseStatus.message : null}
                            />
                        </Grid>
                        <Grid item xs={8}>
                        </Grid>

                        {/*row*/}
                        <Grid item xs={4} style={{ display: "flex", alignItems: "center" }}>
                            {defaultValues.lCourseRegistration.pdfCertificateKey && (              
                                <React.Fragment key="certificateDownload">
                                    <Link onClick={() => downloadCertificateDoc(defaultValues.lCourseRegistration.pdfCertificateKey)}>Download <FileDownloadIcon /></Link>
                                </React.Fragment>
                            )}
                        </Grid>
                        <Grid item xs={8}>
                            <label htmlFor="upload-certificate">
                                <input
                                type="file" accept="application/pdf"
                                    id="upload-certificate"
                                    name="upload-certificate"
                                    style={{ display: 'none' }}
                                    onChange={(event) => {
                                        uploadCertificate(event.target.files[0]);
                                    }}
                                />
                                <Box sx={{ m: 1, position: 'relative' }}>
                                    <Button color="primary" variant="contained" component="span" disabled={isUploadingData}>
                                        Incarca
                                    </Button> (.pdf)
                                    {isUploadingData && (
                                        <CircularProgress 
                                            size={25} 
                                            sx={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                marginTop: '-12px',
                                                marginLeft: '-12px',
                                            }}
                                        />
                                    )}
                                </Box>
                            </label>
                        </Grid>

                        {/*row*/}
                        <Grid item xs={12} container justifyContent="flex-end" alignItems="flex-end">
                            <Button variant="outlined" type="submit" sx={{ marginRight: 1}}>Salveaza</Button>
                        </Grid>

                    </Grid>
                </form>

                    <Grid container spacing={2} sx={CustomStyles.gridStyles}>

                        {/*row*/}
                        <Grid item xs={12}>
                            <EmailRegistrationDialog
                                buttonName={'Trimite E-mail'} 
                                authorization={props.authorization}
                            />
                        </Grid>

                        {/*row*/}
                        <Grid item xs={3}>
                            <Typography color="text.primary" paddingTop={0} >Modificat de</Typography>
                        </Grid>
                        <Grid item xs={9}>
                            {props.authorization.updateBy?.updateByFullName ?
                                props.authorization.updateBy.updateByFullName + ' - ' + props.authorization.updateBy.updateByClient
                                    :
                                ''
                            }
                        </Grid>

                        {/*row*/}
                        <Grid item xs={3}>
                            <Typography color="text.primary" paddingTop={0} >Data modificare</Typography>
                        </Grid>
                        <Grid item xs={9}>
                            {Formatter.formatDateTimetoRO(props.authorization.updateDate)}
                        </Grid>

                    </Grid>

            </Stack>
        </Box>
        </Container>
    );    
}

export default AuthzIscirCourseManagement;